<template>
  <div>
    <v-card-title class="justify-center cta-card-title">
      <span class="cta-text justify-center"> {{ ctaText }} </span>
    </v-card-title>
    <v-card-actions class="justify-center cta-card-actions">
      <v-btn
        class="cta-button text-none"
        variant="flat"
        color="primary"
        :ripple="{ class: 'text-white' }"
        block
        @click="showDialog"
      >
        {{ buttonTitle }}
      </v-btn>
    </v-card-actions>

    <v-snackbar v-model="alert" :color="alertColor" multi-line top>
      {{ alertText }}
    </v-snackbar>

    <v-dialog v-model="dialog" persistent max-width="600" scrollable>
      <v-card>
        <v-card-title>
          <v-toolbar color="white" class="agent-referral-note">
            <v-toolbar-title class="text-h6">
              {{ title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card-title>

        <v-card-text class="pt-0 pb-6 px-11">
          {{ description }}
        </v-card-text>
        <v-card-actions class="mb-4">
          <v-spacer />
          <v-btn
            color="btncolor"
            class="rounded-button mr-1 text-none"
            style="width: 120px"
            @click="closeDialog"
            variant="text"
            large
          >
            {{ "Cancel" }}
          </v-btn>
          <v-btn
            color="btncolor"
            @click="sendEmailToSales"
            class="rounded-button mr-6 text-none"
            :disabled="sendingEmail"
            :dark="!sendingEmail"
            style="width: 180px"
            variant="flat"
            large
          >
            {{ "Contact me" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "@/services/api.js";
import { mapGetters } from "vuex";
import useAuthMixin from "@/mixins/auth.js";

export default {
  name: "OverviewCallToActionWidget",
  data() {
    return {
      sendingEmail: false,
      dialog: false,
      alert: false,
      alertColor: "success",
      alertText: {
        type: String,
        default: "",
      },
    };
  },
  props: {
    title: {
      type: String,
      default: "IRIS",
    },
    description: {
      type: String,
      default: "Click apply now button to get more information.",
    },
    buttonTitle: {
      type: String,
      default: "Learn More",
    },
    ctaText: {
      type: String,
      default: "Want to learn more about this data? Inquire about IRIS today!",
    },
  },
  computed: {
    ...mapGetters("auth", ["impBrokerage"]),
    ...mapGetters("user", ["me", "myBrokerage", "isBrokerAdmin"]),
  },
  methods: {
    ...useAuthMixin(),
    showAlert() {
      this.alertColor = "success";
      this.alertText = "Inquiry Sent: Contact info sent to sales";
      this.alert = true;
      console.log("Should be dialog here!");
    },
    showDialog() {
      console.log("Why not showing??");
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.sendingEmail = false;
    },
    async sendEmailToSales() {
      this.sendingEmail = true;
      console.log("this.isBrokerAdmin: " + this.isBrokerAdmin);

      if (!this.isBrokerAdmin) {
        this.closeDialog();
        this.alertText = "Email not sent due to impersonation.";
        this.alertColor = "error";
        this.alert = true;
        return;
      }

      let errorOccurred = false;
      let brokerName =
        this.me.firstName && this.me.lastName
          ? this.me.firstName + " " + this.me.lastName
          : "Not Available";
      let brokerageName =
        this.myBrokerage.name && this.myBrokerage.name.length > 0
          ? this.myBrokerage.name
          : "Not Available";
      let brokerEmail =
        this.me.email.length && this.me.email.length > 0
          ? this.me.email
          : "Not Available";
      // Email message body
      let messageBody = `Broker Name: ${brokerName}<br>Broker Email: ${brokerEmail}<br>Brokerage Name: ${brokerageName}<br>This broker inquired via a IRIS widget in Insights.`;

      // Email subject line
      let subject =
        brokerName !== "Not Available"
          ? brokerName +
            " has inquired about IRIS via an Insights " +
            this.title +
            " widget."
          : "This broker" +
            " inquired via a IRIS " +
            this.title +
            " widget in Insights";

      try {
        let data = {
          bccAddresses: [],
          toAddresses: ["sales@primestreet.io"], // is this broker or user who is logged in email?
          fromAddress: "sales@primestreet.io",
          messageBody: messageBody,
          subject: subject,
        };
        console.log("============Email data payload below============");
        console.log(data);
        let { status } = await api.agent.email(data);
        console.log(status);
      } catch (e) {
        this.errorCheck(e);
        errorOccurred = true;
      } finally {
        this.sendingEmail = false;
        this.closeDialog();
        if (errorOccurred) {
          this.alertColor = "error";
          this.alertText = "Unable to send an inquiry, please try again.";
        } else {
          this.alertColor = "success";
          this.alertText = "Inquiry Sent: Contact info sent to sales";
        }
        this.alert = true;
      }
    },
  },
  mounted() {
    console.log("MOUNTED CTA WIDGET! " + this.title);
    console.log(this.me);
  },
};
</script>

<style scoped>
.dialog-title {
  font-size: 24px;
}
.cta-card-title {
  text-align: center;
  white-space: unset !important;
  padding-top: 48px;
  padding-bottom: 24px;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.05),
    rgba(255, 255, 255, 0.9),
    rgba(255, 255, 255, 0.95),
    rgba(255, 255, 255, 1)
  );
}
.cta-text {
  width: 75%;
  text-align: center;
  word-break: break-word;
}

.cta-card-actions {
  padding: 0 16px 16px;
  background-color: white;
}

.cta-button {
  max-width: 440px;
}

.dialog-text {
  color: black;
}
.cta-button :deep(.v-btn__content) {
  color: white !important;
  font-size: 16px;
}
</style>
